import { ImageHighlightCard } from '@/components/ui/data-display/cards/ImageHighlightCard';
import { HighlightSection } from '@/components/ui/layouts/sections/HighlightSection';
import { carouselImageSettings } from '@mage-ui/styled-system/recipes';
import { InstancesCarousel } from '../InstancesCarousel';

export const LargeCarouselImageHighlightBlock = ({ data }) => {
  return (
    <HighlightSection
      heading={{
        epi: data?.fields?.epi,
      }}
    >
      <ImageHighlightCard
        data={{
          title: data?.fields?.title,
          cta_text: data?.fields?.cta_text,
          cta_slug: data?.fields?.cta_slug,
          description: data?.fields?.description,
          cta_description: data?.fields?.cta_description,
        }}
      >
        <InstancesCarousel
          indicatorThreshold={1}
          settings={carouselImageSettings()}
          instances={data?.relations?.LargeCarouselImageList}
        />
      </ImageHighlightCard>
    </HighlightSection>
  );
};
